import React from "react";
import BaseSpread, { CardPosition } from "./BaseSpread";

// Generate position data for Astrological spread (13 cards: 12 in a circle + 1 center)
// Cards are arranged in a circle starting from the 9 o'clock position (1st house)
// and moving counterclockwise through the 12 astrological houses, with a 13th card in center
const generateAstrologicalPositions = (spacing: number = 12): CardPosition[] => {
    const cardHeight = spacing * 1.726; // Maintain card aspect ratio (standard tarot card ratio)
    const centerX = 45; // Center of the circle (percentage)
    const centerY = 50; // Center of the circle (percentage)
    const radius = 40; // Radius of the circle (percentage from center)

    const positions: CardPosition[] = [];

    // Calculate positions for 12 cards in a circle
    // Start at 9 o'clock position (270 degrees) and move counterclockwise
    for (let i = 0; i < 12; i++) {
        // Calculate angle for each card (starting at 270 degrees, moving counterclockwise)
        const angle = (270 + (i * 30)) * (Math.PI / 180); // 30 degrees between each card

        // Calculate x and y positions
        const x = centerX + (radius * Math.cos(angle)) - (spacing / 2);
        const y = centerY + (radius * Math.sin(angle)) - (cardHeight / 2);

        positions.push({
            left: x,
            top: y,
            width: spacing,
            height: cardHeight
        });
    }

    // Add the 13th card in the center
    positions.push({
        left: centerX - (spacing / 2),
        top: centerY - (cardHeight / 2),
        width: spacing,
        height: cardHeight
    });

    return positions;
};

interface AstrologicalSpreadProps {
    size?: number;
    cardWidth: number;
    displaySpread: boolean;
    getCard: (index: number) => React.ReactNode;
    spacing?: number; // Spacing between cards (default: 12)
}

const AstrologicalSpread = ({ size, cardWidth, displaySpread, getCard, spacing = 10 }: AstrologicalSpreadProps) => {
    const positions = generateAstrologicalPositions(spacing);

    return (
        <BaseSpread
            positions={positions}
            size={size}
            cardWidth={cardWidth}
            displaySpread={displaySpread}
            getCard={getCard}
            rotatedCards={[]} // No rotated cards in astrological spread
            name="astrological"
        />
    );
};

export default AstrologicalSpread; 